import {useState} from 'react'
import {NavLink} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {AlertTriangleGlyph, ChevronGlyph} from '@/components/ui/icons'
import {Button} from '@/components/ui/button'
import {cn} from '@/lib/utils'

/** Not gated by `sgsst_operar`: any worker in any role can report (spec-incidentes-flujo §2.2). */
export function ReportarButtons({businessId}: {businessId: string}) {
  const {t} = useTranslation()
  return (
    <div className="hidden items-center gap-1.5 md:flex">
      <Button asChild variant="outline" size="sm" data-testid="nav-reportar-incidente">
        <NavLink to={`/businesses/${businessId}/incidentes/reportar`}>{t('nav.reportarIncidente')}</NavLink>
      </Button>
      <Button asChild variant="outline" size="sm" data-testid="nav-reportar-incapacidad">
        <NavLink to={`/businesses/${businessId}/incapacidades/reportar`}>{t('nav.reportarIncapacidad')}</NavLink>
      </Button>
    </div>
  )
}

export function ReportarDropdown({businessId}: {businessId: string}) {
  const {t} = useTranslation()
  const [open, setOpen] = useState(false)
  return (
    <div className="relative md:hidden">
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute top-full right-0 z-50 mt-2 min-w-52 overflow-hidden rounded-xl border border-border bg-popover text-foreground shadow-pop">
            <NavLink
              to={`/businesses/${businessId}/incidentes/reportar`}
              data-testid="nav-reportar-incidente"
              onClick={() => setOpen(false)}
              className="block w-full cursor-pointer px-3 py-2 text-left text-sm hover:bg-secondary">
              {t('nav.reportarIncidente')}
            </NavLink>
            <NavLink
              to={`/businesses/${businessId}/incapacidades/reportar`}
              data-testid="nav-reportar-incapacidad"
              onClick={() => setOpen(false)}
              className="block w-full cursor-pointer border-t border-border px-3 py-2 text-left text-sm hover:bg-secondary">
              {t('nav.reportarIncapacidad')}
            </NavLink>
          </div>
        </>
      )}
      <button
        type="button"
        data-testid="nav-reportar"
        aria-expanded={open}
        aria-haspopup="menu"
        title={t('nav.reportar')}
        onClick={() => setOpen(!open)}
        className={cn(
          'flex min-h-11 cursor-pointer items-center gap-2 rounded-lg px-2.5 py-1.5 text-sm font-medium outline-none focus-visible:ring-2 focus-visible:ring-ring/50 md:min-h-0',
          open ? 'bg-accent text-primary' : 'text-foreground hover:bg-accent hover:text-primary'
        )}>
        <span aria-hidden="true" className="text-primary">
          <AlertTriangleGlyph />
        </span>
        <span className="hidden sm:block">{t('nav.reportar')}</span>
        <ChevronGlyph size={10} className="hidden sm:block" />
      </button>
    </div>
  )
}
